import { Client } from 'openapi-fetch'

import type { paths } from '@kidzonet/ts-api-generator/clients/control-auth'

import { getSessionFromResponse } from './Serializers'

declare global {
    // eslint-disable-next-line vars-on-top
    var ControlAuthApiClient: Client<paths>
}

export const getCurrentUserSessions = async () => {
    const { data, error } = await window.ControlAuthApiClient.GET(
        '/sessions',
    )

    if (error) {
        throw error
    }
    const { items = [] } = data
    return items.map(getSessionFromResponse)
}

export const deleteSession = async (id: string) => {
    const { error } = await window.ControlAuthApiClient.DELETE(
        `/sessions/{session_id}`,
        {
            params: { path: { session_id: id } },
        },
    )

    if (error) {
        throw error
    }
    return true
}
